import { render, staticRenderFns } from "./article-detail.vue?vue&type=template&id=2c422b4a&scoped=true"
import script from "./article-detail.vue?vue&type=script&lang=js"
export * from "./article-detail.vue?vue&type=script&lang=js"
import style0 from "./article-detail.vue?vue&type=style&index=0&id=2c422b4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c422b4a",
  null
  
)

export default component.exports